class Localstorage {
    constructor() {
        this.storage = window.localStorage
    }
    get (key) {
        return this.storage.getItem(key)
    }
    set (key, value) {
        return this.storage.setItem(key, value)
    }
}

export default new Localstorage()